export const PAYMENT_STEPS = {
  SELECT: 1,
  CONFIRM: 2,
  COMPLETE: 3,
} as const;

export type PaymentStep = (typeof PAYMENT_STEPS)[keyof typeof PAYMENT_STEPS];

/** どの画面での決済なのかを識別するための画面種別 */
export const PAYMENT_PAGE_TYPE = {
  NOTICE: 'NOTICE',
  MONTHLY_LIST: 'MONTHLY_LIST',
  RENEWAL: 'RENEWAL',
};
/** 決済画面種別 */
export type PaymentPageType = keyof typeof PAYMENT_PAGE_TYPE;

/** 決済利用種別 */
export const MONTHLY_PAYMENT_USAGE = {
  EXIT_PARKING: 'EXIT_PARKING',
  MONTHLY_APPLICATION_INITIAL_PAYMENT: 'MONTHLY_APPLICATION_INITIAL_PAYMENT',
  MONTHLY_APPLICATION_RENEWAL_PAYMENT: 'MONTHLY_APPLICATION_RENEWAL_PAYMENT',
  MONTHLY_BILLING_PAYMENT: 'MONTHLY_BILLING_PAYMENT',
} as const;
